export default __webpack_public_path__ + "static/pnews_3-bf6161742e4e96de56b299ae4c783a89.png";